import React from 'react';
import { RenderNode } from '@contentful/rich-text-react-renderer';
import { BLOCKS } from '@contentful/rich-text-types';
import { ResponsiveProp, ColumnWidth } from '@belong/types';
import { RegionalCountriesList } from '@belong/ui-components';

import { StyledCopy, StyledList, StyledListItem } from './view.styles';
import { Variants } from './model';

const advancedStylingRenderers = {
  renderNode: {
    // eslint-disable-next-line react/display-name
    [BLOCKS.PARAGRAPH]: (_, children) => (
      <StyledCopy variant="medium" as="div">
        {children}
      </StyledCopy>
    ),
    [BLOCKS.UL_LIST]: (_, children) => <StyledList className="list">{children}</StyledList>,
    [BLOCKS.LIST_ITEM]: (_, children) => <StyledListItem className="listItem">{children}</StyledListItem>
  },
  renderEmbeddedInlines: {
    countryList: entryProps => {
      const { fields } = entryProps?.data?.target || {};
      const { countries = [], showCountriesLinkLabel, hideCountriesLinkLabel } = fields || {};

      return (
        <RegionalCountriesList
          countries={countries}
          showCountriesLinkLabel={showCountriesLinkLabel}
          hideCountriesLinkLabel={hideCountriesLinkLabel}
        />
      );
    }
  },
  gridSize: { md: '5/6', xl: '7/12' } as ResponsiveProp<ColumnWidth>
};

interface IStylingRenderers {
  renderNode?: RenderNode;
  renderEmbeddedInlines?: RenderNode;
  gridSize?: ResponsiveProp<ColumnWidth>;
}

export const getVariantStyling = (variant?: Variants): IStylingRenderers => {
  if (!variant) {
    return {};
  }

  if (variant === 'Advanced styling') {
    return advancedStylingRenderers;
  }

  return {};
};
